export const SET_HRES85U_INDEX_DISP = 'SET_HRES85U_INDEX_DISP'
export const GET_HRES85U_INDEX_DISP = 'GET_HRES85U_INDEX_DISP'
export const SET_HRES85U_DETAIL_DISP = 'SET_HRES85U_DETAIL_DISP'
export const GET_HRES85U_DETAIL_DISP = 'GET_HRES85U_DETAIL_DISP'
export const SET_HRES85U_MAX_ROWSPAN = 'SET_HRES85U_MAX_ROWSPAN'
export const GET_HRES85U_MAX_ROWSPAN = 'GET_HRES85U_MAX_ROWSPAN'
export const SET_HRES85U_COLUMNS = 'SET_HRES85U_COLUMNS'
export const GET_HRES85U_COLUMNS = 'GET_HRES85U_COLUMNS'
export const SET_HRES85U_LABELS = 'SET_HRES85U_LABELS'
export const GET_HRES85U_LABELS = 'GET_HRES85U_LABELS'
export const RECEIVED_HRES85U_COLUMNS_LABELS = 'RECEIVED_HRES85U_COLUMNS_LABELS'
export const SET_HRES85U_INDEX = 'SET_HRES85U_INDEX'
export const GET_HRES85U_INDEX = 'GET_HRES85U_INDEX'
export const RECEIVED_HRES85U_INDEX = 'RECEIVED_HRES85U_INDEX'
export const SET_HRES85U_INDEX_SELECTED = 'SET_HRES85U_INDEX_SELECTED'
export const GET_HRES85U_INDEX_SELECTED = 'GET_HRES85U_INDEX_SELECTED'
export const SET_HRES85U_DETAIL = 'SET_HRES85U_DETAIL'
export const GET_HRES85U_DETAIL = 'GET_HRES85U_DETAIL'
export const RECEIVED_HRES85U_DETAIL = 'RECEIVED_HRES85U_DETAIL'
export const TOGGLE_HRES85U_PAGE = 'TOGGLE_HRES85U_PAGE'
export const POST_HRES85U_SEND_APPROVE = 'POST_HRES85U_SEND_APPROVE'
export const RECEIVED_HRES85U_DROPDOWNS = 'RECEIVED_HRES85U_DROPDOWNS'
export const SET_HRES85U_DROPDOWNS = 'SET_HRES85U_DROPDOWNS'
export const GET_HRES85U_DROPDOWNS = 'GET_HRES85U_DROPDOWNS'

export const SET_HRES85U_DETAIL_SUBMIT = 'SET_HRES85U_DETAIL_SUBMIT'
export const GET_HRES85U_DETAIL_SUBMIT = 'GET_HRES85U_DETAIL_SUBMIT'
export const RECEIVED_HRES85U_DETAIL_SUBMIT = 'RECEIVED_HRES85U_DETAIL_SUBMIT'



// WEBPACK FOOTER //
// ./src/store/modules/hres85u/mutation-types.js